import React, { Suspense, useState } from "react";
import "./index.css";

import {
	HashRouter as Router, 
	Routes, 
	Route, 
	Link,
	useParams
  } from "react-router-dom";

import {
  FormControl,
  InputLabel, 
  Select, 
  MenuItem
} from '@mui/material'

//Components

import SeatApp from './components/SeatApp/App' 
import GraphApp from './components/GraphApp/App'
import BarchartApp from './components/BarchartApp/App'
import FilteredResultsApp from "./components/FilteredResultsApp/App";
import LeadersApp from './components/LeadersApp/App';
import OverviewApp from './components/OverviewApp/App'
import Loading from './utilities/Loading'

import DataContextProvider from './dataContext'

const MapApp = React.lazy(()=>import('./components/MapApp/App'));

const InstantArticleApp = React.lazy(()=>import('./components/InstantArticle/InstantArticleApp'));


const App = () => {

	return (
		<Router>
			<Routes>
				<Route path="/" element={<Home/>} />
				<Route path="/map/:prov/:year/" element={<Map />} />
				<Route path="/map/:prov/:year/:riding" element={<Map />} />
				<Route path="/seat/:prov/:year" element={<Suspense fallback={<Loading />}>
					<DataContextProvider>
						<SeatApp />
					</DataContextProvider>
					</Suspense>} />
				<Route path="/graph/:prov/:year" element={<DataContextProvider>
					<GraphApp />
				</DataContextProvider>} />
				<Route path="/barchart/:prov/:year" element={<DataContextProvider>
					<BarchartApp />
					</DataContextProvider>
					} />
				<Route path="/filteredResults/:prov/:year" element={<DataContextProvider>
					<FilteredResultsApp />
					</DataContextProvider>
					} />
				<Route path="/filteredResults/:prov/:year/:loadfilter" element={<DataContextProvider>
					<FilteredResultsApp />
					</DataContextProvider>
					} />
				<Route path="/leaders/:prov/:year" element={<DataContextProvider>
						<LeadersApp />
					</DataContextProvider>} />
				<Route path="/instantarticle/:prov/:year" element={<Suspense fallback={<Loading />}>
					<DataContextProvider>
						<InstantArticle />
					</DataContextProvider>
					</Suspense>
					} />
				<Route path="/instantarticle/:prov/:year/:riding" element={
					<Suspense fallback={<Loading />}>
						<DataContextProvider>
							<InstantArticle />
						</DataContextProvider>
					</Suspense>
				} />
				<Route path="/overview/:prov/:year" element={<Suspense fallback={<div>Loading..</div>}>
					<DataContextProvider>
						<OverviewApp />
					</DataContextProvider>
					</Suspense>
					} />
				</Routes>
	  </Router>
	);
}

const Home = () => {
  const [prov, setProv] = useState({prov: 'ab', year: 2023});
	return (
	<div className="p-4">
		<FormControl className="max-w-lg" fullWidth>
			<InputLabel className="bg-white px-1" id="demo-simple-select-label">Select Election</InputLabel>
			<Select
				labelId="demo-simple-select-label"
				id="demo-simple-select"
				value={prov}
				onChange={(e)=>setProv(e.target.value)}
			>
				{window.CONFIG.elections.map((el)=>{
				return <MenuItem value={el}>{el.prov} - {el.year}</MenuItem>
				})}
			</Select>
		</FormControl>
		<ul className="px-1">
			<li className=" text-cyan-800 hover:underline">
				<Link to={`/`}>Home</Link>
			</li>
			<li className=" text-cyan-800 hover:underline">
				<Link to={`/map/${prov.prov}/${prov.year}`}>Map App</Link>
			</li>
			<li className=" text-cyan-800 hover:underline">
				<Link to={`/barchart/${prov.prov}/${prov.year}`}>Barchart App</Link>
			</li>
			<li className=" text-cyan-800 hover:underline">
				<Link to={`/graph/${prov.prov}/${prov.year}`}>Graph App</Link>
			</li>
			<li className=" text-cyan-800 hover:underline">
				<Link to={`/seat/${prov.prov}/${prov.year}`}>Seat App</Link>
			</li>
			<li className=" text-cyan-800 hover:underline">
				<Link to={`/instantarticle/${prov.prov}/${prov.year}`}>Instant Article</Link>
			</li>
			<li className=" text-cyan-800 hover:underline">
				<Link to={`/filteredResults/${prov.prov}/${prov.year}/close`}>Playlist Results</Link>
			</li>
			<li className=" text-cyan-800 hover:underline">
				<Link to={`/overview/${prov.prov}/${prov.year}`}>Simple Overview App w/link</Link>
			</li>
			<li className=" text-cyan-800 hover:underline">
				<Link to={`/leaders/${prov.prov}/${prov.year}`}>Party Leaders</Link>
			</li>
		</ul>
	</div>
	)
}

const Map = () => {
    return (
        <Suspense fallback={<Loading />}>
			<DataContextProvider>
				<MapApp showBanner={true}/>
			</DataContextProvider>
        </Suspense>
    )
}

const InstantArticle = () => {
	return (
		<div className={"flex relative  flex-col h-full gap-1"}>
			<div className={'max-h-40'}>
				<InstantArticleApp />
			</div>
			<div className={'max-h-full flex-grow-1 overflow-hidden relative'} >
				<MapApp showBanner={false}/>
			</div>
		</div>
	)
}
export default App;

// style={{flexGrow: '1', width: '100%', position: 'relative', overflow: 'auto'}}